import { createSelector } from 'reselect'
import get from 'lodash/get'
import includes from 'lodash/includes'
import without from 'lodash/without'
import {SUCCESS} from '../../../store/shared/currentUserDuck'

const OPEN = 'steppingblocks/interestSelector/OPEN'
const CLOSE = 'steppingblocks/interestSelector/CLOSE'
const TOGGLE_OPTION = 'steppingblocks/interestSelector/TOGGLE_OPTION'

const initialState = {
  isShowingModal: false,
  selectedOptions: [],
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case OPEN:
      return { ..._state, isShowingModal: true }
    case CLOSE:
      return { ..._state, isShowingModal: false }
    case TOGGLE_OPTION:
      return {
        ..._state,
        selectedOptions: includes(get(_state, 'selectedOptions') , get(payload, 'option'))
          ? without(_state.selectedOptions, payload.option)
          : _state.selectedOptions.concat(payload.option),
      }
    case SUCCESS:
      return {
        ..._state,
        selectedOptions: payload.user.interests,
      }
    default:
      return _state
  }
}

export const openModal = () => ({ type: OPEN })

export const closeModal = () => ({ type: CLOSE })

export const toggleOption = option => ({
  type: TOGGLE_OPTION,
  payload: { option },
})

export const getIsShowingModal = createSelector(
  state => state.interestSelector,
  interestSelector => interestSelector.isShowingModal,
)

export const getSelectedOptions = createSelector(
  state => state.interestSelector,
  interestSelector => interestSelector.selectedOptions,
)



// WEBPACK FOOTER //
// ./src/components/ui/InterestSelector/interestSelectorDuck.js